import { GitBranch } from "lucide-react";
import type { TreeNode } from "@/types/club";

export function EntryTreeMini({ node }: { node: TreeNode }) {
  return (
    <div className="space-y-3 text-sm">
      <div className="flex items-center justify-between">
        <span className="text-surface-500">Depth</span>
        <span className="font-semibold text-surface-800">L{node.depth}</span>
      </div>
      <div className="flex items-center justify-between">
        <span className="text-surface-500">Sibling index</span>
        <span className="font-semibold text-surface-800">#{node.sibling_index}</span>
      </div>
      <div className="flex items-center justify-between">
        <span className="text-surface-500">Direct children</span>
        <span className="font-semibold text-surface-800">{node.child_count}</span>
      </div>
      {node.parent_entry_id ? (
        <div>
          <div className="text-surface-500 mb-1">Parent</div>
          <div className="font-mono text-xs bg-surface-50 border border-surface-200 rounded px-2 py-1.5">
            {node.parent_entry_id}
          </div>
        </div>
      ) : (
        <div className="text-2xs text-surface-500 italic">This is the root node.</div>
      )}
      <div>
        <div className="text-surface-500 mb-1 flex items-center gap-1">
          <GitBranch className="h-3.5 w-3.5" /> Path
        </div>
        <div className="font-mono text-2xs text-surface-700 bg-surface-50 border border-surface-200 rounded px-2 py-1.5 break-all">
          {node.path}
        </div>
      </div>
    </div>
  );
}
